"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var L = require("leaflet");
require("polyline-encoded");
require("leaflet.markercluster");
(function () {
    var pseudoCheck = 'false';
    if (pseudoCheck === 'true')
        new L.Map('#this-should-never-happen'); // This should never happen and is just here to create this file
})();
